<script>
    import { slide } from 'svelte/transition';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function remove() {
        dispatch('remove', { id });
    }
    function toggleStatus() {
        let newStatus = !complete;

        dispatch('toggle', {
            id,
            newStatus
        })
    }

    export let id;
    export let text;
    export let complete;
    console.log(text, id)
</script>

<style>
    .is-complete {
        text-decoration: line-through;
        color: #63f2f5;
    }
    li {
        position: relative;
        display: flex;
        align-items: center;
        padding: .2em 1em;
        font-size: 1.2em;
    }
    li:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 12%;
        right: 12%;
        height: 2px;
        background: #222228;
        border-radius: 1px;
    }
    span {
        margin: 0 auto 0 .8em;
        font-weight: 300;
    }
    button.check {
        position: relative;
        width: 50px;
        height: 50px;
    }
    button.check:after {
        content: '';
        position: absolute;
        width: 30px;
        height: 30px;
        top: 8px;
        left: 8px;
        border: 1px solid rgba(39, 95, 96, .5);
        border-radius: 50%;
    }
    button.check.is-complete-btn:after {
        border: none;
        background: rgba(39, 95, 96, .5);
    }
    .is-complete-btn:before {
        content: 'L';
        position: absolute;
        font-size: 24px;
        top: 7px;
        left: 17px;
        -webkit-transform: scaleX(-1) rotate(-35deg);
        transform: scaleX(-1) rotate(-35deg);
        z-index: 1;
        color: #63f2f5;
    }
    button.trash {
        height: 50px;
        width: 50px;
        font-size: 20px;
        border: none;
    }
    button.trash svg {
        height: 25px;
        fill: #fd754a;
        border: none;
    }
</style>

<li in:slide out:slide>
    {#if complete}
        <button on:click={toggleStatus} class="check is-complete-btn"></button>
        <span class="is-complete">{text}</span>
    {:else}
        <button on:click={toggleStatus} class="check"></button>
        <span>{text}</span>
    {/if}
    <button on:click={remove} class="trash">
        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32"><path d="M 15 4 C 14.476563 4 13.941406 4.183594 13.5625 4.5625 C 13.183594 4.941406 13 5.476563 13 6 L 13 7 L 7 7 L 7 9 L 8 9 L 8 25 C 8 26.644531 9.355469 28 11 28 L 23 28 C 24.644531 28 26 26.644531 26 25 L 26 9 L 27 9 L 27 7 L 21 7 L 21 6 C 21 5.476563 20.816406 4.941406 20.4375 4.5625 C 20.058594 4.183594 19.523438 4 19 4 Z M 15 6 L 19 6 L 19 7 L 15 7 Z M 10 9 L 24 9 L 24 25 C 24 25.554688 23.554688 26 23 26 L 11 26 C 10.445313 26 10 25.554688 10 25 Z M 12 12 L 12 23 L 14 23 L 14 12 Z M 16 12 L 16 23 L 18 23 L 18 12 Z M 20 12 L 20 23 L 22 23 L 22 12 Z"/></svg>
    </button>
</li>